<template>
  <div class="containter">
    <div class="h-bg">
      <div class="header-box">
        <div class="header-box-left">
          <div class="top-time">
            <el-image style="width: 26px; height: 25px;margin-right: 9px"
                      :src="require('@/assets/images/header/dateTime.png')" fit="cover"></el-image>
            <div>
              <div class="f11">{{ nowTimeDay }}</div>
              <div class="f16" style="letter-spacing:2px">{{ nowTimeSecond }}</div>
            </div>
          </div>
        </div>
        <el-button class="top-btn" @click="goto('/kejiaohui')"
                   :class="['btn-item',{'active':headerBtn==='/kejiaohui'}]">科交会主屏
        </el-button>
        <el-button class="top-btn" @click="goto('/allcollege/echartsMap')"
                   :class="['btn-item',{'active':headerBtn==='/allcollege/echartsMap'}]">全国高校专利分布
        </el-button>
        <div class="title f40">第三届（2023）中国高校科技成果交易会</div>
        <el-button class="top-btn" @click="goto('/kejiaohui/PatentStatisticalAnalysis')"
                   :class="['btn-item',{'active':headerBtn==='/kejiaohui/PatentStatisticalAnalysis'}]">全国高校专利统计
        </el-button>
        <el-button class="top-btn" @click="goto('/allcollege/patent/list')"
                   :class="['btn-item',{'active':headerBtn==='/allcollege/patent/list'}]">全国高校专利搜索
        </el-button>
        <el-button class="top-btn" @click="goto('/kejiaohui/EnterpriseValueAnalysis/list')"
                   :class="['btn-item',{'active':headerBtn==='/kejiaohui/EnterpriseValueAnalysis/list'}]">企业价值分析
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapGetters, mapActions} from "vuex";
import Search from '@/components/common/search.vue'
import {storePersistKey} from "@/plugins/tools/Constant";
import {errorToast, successToast} from "@/plugins/tools/util";
import screenfull from "screenfull/dist/screenfull"

export default {
  props: [],
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {
        console.log('to', to)
        const path = to.path
        this.headerBtn = path
      },
    }
  },
  components: {
     Search,
  },
  computed: {
    ...mapGetters({
      token: "userStore/token",
      userName: "userStore/userName",
      userId: "userStore/userId",
      current_site:'current_site',
      permissions: 'permissions'
    }),
  },
  mounted() {
    this.getNowTime()
    clearInterval(myTimeDisplay)
    var myTimeDisplay = setInterval(() => {
      this.getNowTime()
    }, 1000)
  },
  inject: ["reload", "msg"],
  data() {
    return {
      nowTimeDay: '',
      nowTimeSecond: '',
      headerBtn: '',//一级路由
    }

  },
  destroy () {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.fullChange)
    }
  },
  created() {

  },
  methods: {
    getNowTime() {
      var date = new Date()
      let days = ['一', '二', '三', '四', '五', '六', '日']
      var nowTimeDay = date.getFullYear() + '/' + this.addZero(date.getMonth() + 1) + '/'
        + this.addZero(date.getDate()) + ' 周' + (date.getDay()==0?'日':days[date.getDay() - 1])
      var nowTimeSecond = this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':'
        + this.addZero(date.getSeconds())
      this.nowTimeDay = nowTimeDay
      this.nowTimeSecond = nowTimeSecond
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    goto(path) {
      this.$router.push({
        path
      })
    },
    //退出登录
    logout() {
      this.$cookies.remove('token')
      localStorage.removeItem(storePersistKey)
      this.$store.dispatch('userStore/clearToken')
      successToast("退出登录成功")
      this.$router.push({path: '/'})
    },
  }
}

</script>

<style scoped lang="scss">
.h-bg {
  height: 112px;
  width: 100%;
  background: url(~@/assets/images/header/h-bg.png) center/cover;

  .header-box {
    @include flex(space-around);
    height: 80px;
    padding: 0 1%;

    .header-box-left,.header-box-right{
      width: 580px;
      @include flex(flex-start);
    }
    .btn-item {
      width: 170px;
      height: 34px;

      &.active {
        color: $mainColor-active;
        border-color: $mainColor-active;
        font-weight: bold;
        box-shadow: inset 0px 0px 10px 0px rgba(248, 197, 100, .7);
      }
    }

    .fullbtn {
      @include flex();
      color: #23E9FD;
      cursor: pointer;
      font-size: 16px;
      margin-left: 20px;

      img {
        height: 32px;
        width: 32px;
        margin-right: 8px
      }
    }

    .top-time {
      @include flex();
      color: #23E9FD;
      flex-shrink: 0;
      margin-right: auto;
    }
    .top-btn{
      margin: 0 30px;
    }
    .title {
      flex-shrink: 0;
      height: 40px;
      font-family: AliHeavy;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      //text-shadow: 0px 0px 16px rgba(0, 150, 255, 0.7), 0px 2px 2px rgba(0, 0, 0, 0.8);
      background: linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
/deep/ .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

/deep/ .el-input__icon {
    height: 34px;
    line-height: 34px;
  }

</style>



// WEBPACK FOOTER //
// src/layoutCollegeAll/components/header.vue